module.exports = __webpack_public_path__ + "cef8b68ba1bf5f382f02ae2cd2188e7c.woff2";